import { formatMoney } from 'helpers/Currency';

export class ItemCardRanking{
  constructor(item){
    this.item = item;
    this.id = `${item.position}-${item.ranking_id}`;
  }

  render(className){
    let item = this.item;
    return `
    <div class="area-item" id="${this.id}">
      <div class="move-ranking-item pos-ranking-${item.position} ${className}">
        <label class="move-ranking-item-technologie-name">${item.technology_name}</label>
        <label class="move-ranking-item-company-name">${item.company_name}</label>
        <label class="move-ranking-item-value">${formatMoney(item.value)}</label>
        <div class="ranking">${item.position}</div>
      </div>
    </div>
    `;
  }

  target(){
    return document.getElementById(this.id);
  }

  box(){
    return {
      width: this.target().offsetWidth,
      height: this.target().offsetHeight
    };
  }

  setStyleCenter(){
    const target = this.target();
    // target.style.zIndex = "10000";
    // target.style.padding = ".6rem 1rem"; 
    const element = target.getElementsByClassName("move-ranking-item")[0]
    // element.style.transform = "scale(1.2)";
    // element.style.boxShadow = "0 0 4px 2px #00000045";
  }

  setStylePreCenter(){
    const target = this.target();
    target.style.zIndex = "";
    target.style.padding = ""; 
    const element = target.getElementsByClassName("move-ranking-item")[0]
    // element.style.transform = "scale(1.1)";
    // element.style.boxShadow = "0 0 4px 2px #00000030";
  }

  clearStyle(){
    const target = this.target();
    target.style.zIndex = "";
    target.style.padding = ""; 
    const element = target.getElementsByClassName("move-ranking-item")[0]
    element.style.transform = "";
    element.style.boxShadow = "";
  }
}